const { entryType, paymentType } = require('@transfeeradev/api-enums').bankStatement;
const { accountType } = require('@transfeeradev/api-enums');
const UtilsService = require('./UtilsService');

class BtgStatementService {
  static formatEntry(entry) {
    const amount = entry.body.amount / 100;
    return {
      identifier: entry.pactualId,
      date: entry.createTimestamp,
      value: amount < 0 ? amount * -1 : amount,
      type: entry.body.cashDirection === 'CashOut' ? entryType.DEBIT : entryType.CREDIT,
      payment_type: BtgStatementService.getPaymentType(entry.body.financialType),
      complement: {
        original_type: entry.body.financialType,
        movement_id: entry.body.movementId,
        client_request_id: entry.clientRequestId,
        status: entry.status,
        ...BtgStatementService._getAccountData(
          entry.body.cashDirection === 'CashOut' ? entry.body.creditParty : entry.body.debitParty
        ),
        transfeera_account: BtgStatementService._getAccountData(
          entry.body.cashDirection === 'CashOut' ? entry.body.debitParty : entry.body.creditParty
        )
      }
    };
  }

  static getPaymentType(type) {
    switch (type) {
      case 'Ted':
      case 'TedSalary':
      case 'TedBankslip':
        return paymentType.TED;
      case 'Tef':
      case 'TefMerchantAccount':
        return paymentType.TEV;
      case 'Bankslip':
      case 'CardBankslip':
        return paymentType.BILLET;
      case 'Pix':
      case 'PixPaymentInbound':
        return paymentType.PIX;
      case 'PixReversalInbound':
      case 'PixReversal':
        return paymentType.PIX_REFUND;
      default:
        if (type.toLowerCase().startsWith('pix')) {
          return paymentType.PIX;
        }
        return paymentType.OTHER;
    }
  }

  static _getAccountData(accountData) {
    if (!accountData) {
      return {};
    }

    return {
      name: accountData.name,
      cpf_cnpj: accountData.taxId,
      account: accountData.account.toString().slice(0, -1),
      account_digit: accountData.account.toString().slice(-1),
      account_type: BtgStatementService._getAccountType(accountData.accountType),
      agency: accountData.branch ? UtilsService.fillZeros(accountData.branch.toString(), 4) : null,
      bank_code: accountData.bank ? UtilsService.fillZeros(accountData.bank.toString(), 3) : null // TODO: Workaround because of PIX transfers to banks without bank code
    };
  }

  static _getAccountType(type) {
    switch (type) {
      case 'CC':
        return accountType.CONTA_CORRENTE;
      case 'CP':
        return accountType.CONTA_POUPANCA;
      case 'PG':
        return accountType.CONTA_PAGAMENTO;
      default:
        return null;
    }
  }
}

module.exports = BtgStatementService;
